import { render } from "./ExternalContextsDataForm.vue?vue&type=template&id=01260027"
import script from "./ExternalContextsDataForm.vue?vue&type=script&lang=js"
export * from "./ExternalContextsDataForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__